<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="任务类型名称">
					<c-input name="type_name" maxlength="50"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_collabtasktype_edit')" v-lock="lock('b_collabtasktype_edit')" prepend-icon="tf-add" @click="editTaskType()">创建任务类型</c-button>

				<template #batch>
					<c-button v-if="auth('b_collabtasktype_print')" v-lock="lock('b_collabtasktype_print')" prepend-icon="tf-print" @click="batchPrintTaskType">打印</c-button>
					<c-button v-if="auth('b_collabtasktype_edit')" v-lock="lock('b_collabtasktype_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveTaskType">删除</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" :paging="true">
				<c-table-column
					type="selector"
					width="32"
					@handle="batchSelect"
				></c-table-column>

				<c-table-column
					label="任务类型名称"
					name="type_name"
					width="200"
				>
					<template #default="{data}">
						<c-state :color="data.color" tag>{{data.type_name}}</c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="标题规则"
					name="title_rule"
					width="240"
				>
					<template #default="{data}">
						<span v-if="data.title_rule">{{titleRuleText(data.title_rule)}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="负责人范围"
					name="user_scope_names"
					width="200"
				>
					<template #default="{data}">
						<span v-if="!data.user_scope_names">-</span>
						<c-tags v-else :value="data.user_scope_names"></c-tags>
					</template>
				</c-table-column>

				<c-table-column
					label="默认负责人"
					name="default_user_realname"
					width="110"
				>
					<template #default="{data}">
						<span v-if="data.default_user_realname">{{data.default_user_realname}}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="150"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_collabtasktype_edit')" v-lock="lock('b_collabtasktype_edit')" icon="tf-edit" @click="editTaskType(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_collabtasktype_print')" v-lock="lock('b_collabtasktype_print')" icon="tf-print" @click="printTaskType(data)">打印</c-table-button>
						<c-table-button v-if="auth('b_collabtasktype_edit')" v-lock="lock('b_collabtasktype_edit')" icon="tf-trash" color="red" @click="removeTaskType(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--创建/编辑任务类型弹窗-->
			<collab-task-type-edit ref="typeEdit" @resolve="$refs.list.update()"></collab-task-type-edit>
		</module>
	</page>
</template>

<script>
	import collabTaskTypeEdit from "@/pages/collab/collab_task_type_edit.vue";
	import {batchData, batchMethods} from '@/components/public/batch.js'
	import {TITLE_RULE_OPTIONS} from '@/pages/collab/collab_task_type_edit.vue'

	export default {
		components: {
			collabTaskTypeEdit
		},

		data() {
			return {
				...batchData()
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/collab/task/type/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
			},

			/****标题规则展示文本****/
			titleRuleText(title_rule) {
				try {
					let codes = title_rule || [];
					return codes.map(code => {
						let option = TITLE_RULE_OPTIONS.find(item => item.value == code);
						return option ? option.name : code;
					}).join('-');
				} catch (e) {
					return '-';
				}
			},

			/****负责人范围展示文本****/
			scopeText(user_scope_json) {
				try {
					let scope = user_scope_json || {};
					let count = (scope.user_ids || []).length;
					let deptCount = (scope.dept_ids || []).length;
					if (!count && !deptCount) return '所有人';
					let texts = [];
					if (count) texts.push(count + '名人员');
					if (deptCount) texts.push(deptCount + '个部门');
					return texts.join('、');
				} catch (e) {
					return '所有人';
				}
			},

			/******新建/编辑任务类型*******/
			editTaskType(data) {
				this.$refs.typeEdit.open(data);
			},

			/******打印任务类型（选择打印模板）*******/
			printTaskType(data) {
				this.globalDialog('exportTemplateSelector', {
					props: {
						workType: 50,
						templateType: 1
					},
					data: {
						htmlParams: {
							ids: data.id,
							export_type: 2
						}
					}
				});
			},

			/******批量打印任务类型*******/
			batchPrintTaskType(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				if (ids.length == 0){
					this.$message({
						message: '请先选择需要打印的任务类型',
						type: 'warn'
					});
					return;
				}
				this.globalDialog('exportTemplateSelector', {
					props: {
						workType: 50,
						templateType: 1
					},
					data: {
						htmlParams: {
							ids: ids.join(','),
							export_type: 2
						}
					}
				});
			},
			
			/****批量删除任务类型****/
			batchRemoveTaskType(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});

				this.$confirm({
					message:'确认删除' + ids.length + '条任务类型记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/collab/task/type/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除任务类型***********/
			removeTaskType(data){
				this.$confirm({
					message:'确认删除任务类型【'+data.type_name+'】？删除后不可恢复',  // 提示内容,
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/collab/task/type/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.color-dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		margin-right: 6px;
		border-radius: 50%;
		vertical-align: middle;
	}
</style>
